import { ControlCategories, PartnerEvents } from "@theprelude/core";
import { MissingControlCategoryCard } from "./missing-control-category-card";

export const MissingEndpointManagementCard = () => (
  <MissingControlCategoryCard
    category={ControlCategories.ASSET_MANAGER}
    partnerEvent={PartnerEvents.NO_ASSET_MANAGER}
    description="Unmanaged devices."
  />
);
